var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('template',{slot:"header"},[_c('DefaultHeader'),_vm._v(" "),_c('ProgressBar',{attrs:{"progress":_vm.progress}})],1),_vm._v(" "),_c('nuxt'),_vm._v(" "),_c('span',{attrs:{"slot":"footer"},slot:"footer"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }